import React from "react";
import FanExploreMore from "./Content/FanExploreMore";
import "./Content/FanStar.css";
import FanYoursGroup from "./Content/FanYoursGroup";

const FanGroup = () => {
  return (
    <>
      <FanYoursGroup />
      <FanExploreMore />
    </>
  );
};

export default FanGroup;
